import type { LibraryItem } from '../lib/api';

export type CategoryFilter = LibraryItem['category'] | 'all';

const categories: { id: CategoryFilter; label: string }[] = [
  { id: 'all', label: 'All' },
  { id: 'blueprint', label: 'Make Blueprint' },
  { id: 'n8n', label: 'n8n Blueprint' },
  { id: 'ebook', label: 'E-book' },
  { id: 'prompt', label: 'Prompt' },
];

type Props = {
  category: CategoryFilter;
  setCategory: (c: CategoryFilter) => void;
  sector: string | null;
  setSector: (s: string | null) => void;
  availableSectors: string[];
};

export default function LibraryFilters({
  category,
  setCategory,
  sector,
  setSector,
  availableSectors,
}: Props) {
  return (
    <div className="space-y-6">
      <div>
        <p className="label mb-3">Category</p>
        <div className="flex flex-wrap gap-2">
          {categories.map((c) => (
            <button
              key={c.id}
              onClick={() => setCategory(c.id)}
              className={`rounded-full border px-4 py-1.5 font-sans text-[0.7rem] uppercase tracking-label transition-colors ${
                category === c.id
                  ? 'border-gold bg-gold text-black'
                  : 'border-white/15 text-white/85 hover:border-white/40'
              }`}
            >
              {c.label}
            </button>
          ))}
        </div>
      </div>

      {availableSectors.length > 0 && (
        <div>
          <p className="label mb-3">Sector</p>
          <div className="flex flex-wrap gap-2">
            <button
              onClick={() => setSector(null)}
              className={`rounded-full border px-4 py-1.5 font-sans text-[0.7rem] uppercase tracking-label transition-colors ${
                !sector
                  ? 'border-gold bg-gold text-black'
                  : 'border-white/15 text-white/85 hover:border-white/40'
              }`}
            >
              All
            </button>
            {availableSectors.map((s) => (
              <button
                key={s}
                onClick={() => setSector(s)}
                className={`rounded-full border px-4 py-1.5 font-sans text-[0.7rem] uppercase tracking-label transition-colors ${
                  sector === s
                    ? 'border-gold bg-gold text-black'
                    : 'border-white/15 text-white/85 hover:border-white/40'
                }`}
              >
                {s}
              </button>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
